module.exports = new __parcel__URL__("volley.9b4cfb33.png").toString();